import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsGear1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSettingsGear1"><Path d="M12 2.5L20.5 7.24995L20.5 16.7499L12 21.4999L3.5 16.7502L3.5 7.24992L12 2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSettingsGear1;
